<template>
  <div class="history">
    <van-nav-bar
        title="历史记录"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    <div class="search">
      <div class="dataTime">
        <div class="search">
          <!-- <van-search
            v-model="searchIdNoValue"
            placeholder="请输入身份证号查询"
            @input="queryInfo"
            @search="queryInfo"
          >
          </van-search> -->
          <van-search
            v-model="searchPlateNoValue"
            placeholder="请输入车牌号码查询"
            @input="queryInfo"
            @search="queryInfo"
          >
          </van-search>
          <!-- <van-divider /> -->
        </div>
        <van-row>
          <van-cell title="查询开始时间：" is-link :value="dataForm.dateBegin" @click="clickBegin(dataForm.dateBegin)" />
          <van-calendar ref="staHistory" :value="dataForm.dateBegin" v-model="showBegin" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
        </van-row>
        <van-row>
          <van-cell title="查询结束时间：" is-link :value="dataForm.dateEnd" @click="showEnd = true" />
          <van-calendar v-model="showEnd" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEnd" />
          <span style="color: #fa8f04;font-weight: bold; font-size: 13px;
            float: right;margin-right: 6%;">{{ queryDataLength }}</span>
        </van-row>
        <!-- <van-divider style="margin: 0;" /> -->
          <!-- <van-row style="margin:0 12px;">
          <van-button round block plain hairline type="info"  @click="onSearch">查 询</van-button>
        </van-row> -->
      </div>
    </div>
    <div class="searchContent">
      <van-list
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-cell v-for="item in queryDataArray" :key="item.id" >
          <!-- <van-row>
            <van-col :span="18">
              <van-row>
                <van-col :span="8" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="16">{{ item.plateNo }}</van-col>
              </van-row>
              <van-row>
                <van-col :span="8" style="text-align: right;">身份证号：</van-col>
                <van-col :span="16">{{ item.idNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="5">
              <van-button  style="height: 42px;" plain hairline type="info" @click="showDetail(item)"
               >{{ item.state==0?'确认取出':item.state==1?'到达服务站':'查看' }}</van-button>
            </van-col>
          </van-row> -->
          <van-row>
            <van-col :span="16">
              <van-row>
                <van-col :span="10" style="text-align: right;">车牌号码：</van-col>
                <van-col :span="12" style="text-align: center;">{{ item.plateNo }}</van-col>
              </van-row>
            </van-col>
            <van-col :span="6">
              <van-button  style="height: 42px; width: 120%;"  plain hairline type="info" @click="showDetail(item)"
               >{{ '查看' }}</van-button>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </div>
    <!-- 0.42667rem -->
    <!-- 450881200010058922 -->
    <!-- 编辑申请信息 -->
        <van-overlay :show="showDataDetail" @click="showDataDetail=false">
          <div class="wrapper" @click.stop>
            <div class="applyBlock">
              <van-form>
                <div class="title">
                <!-- <span>{{ showList.state == 0?'编辑申请信息':'查看申请信息' }}
                  <van-icon name="close" class="cancel" @click="cancelForm"/>
                </span> -->
                <span>详情信息
                  <van-icon name="close" class="cancel" @click="cancelForm"/>
                </span>
              </div>
              <van-field label="车牌号码：" v-model="showList.plateNo" readonly>
              </van-field>
              <van-field label="身份证号："  v-model="showList.idNo" readonly/>
              <van-field label="取出时间："  v-model="showList.getTime" readonly/>
              <van-field label="确认时间："  v-model="showList.confirmTime" readonly/>
              <van-field label="到站时间："  v-model="showList.arriveTime" readonly/>
              <van-field label="创建时间："  v-model="showList.createTime" readonly/>
              <!-- <van-field label="存放位置：" v-model="showList.boxCode" disabled/>
              <van-field label="车牌类型：" :disabled="showList.state == 0 ? false:true">
                <template #input>
                  <van-radio-group v-model="showList.plateType" direction="horizontal" :disabled="showList.state == 0 ? false:true">
                    <van-radio :name= 0 checked-color="#3399ff">蓝牌</van-radio>
                    <van-radio :name= 1 checked-color="#3399ff">绿牌</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              
              <van-field label="申请状态：" v-model="showList.stateDescription" disabled />
              <van-field label="创建时间： " v-model="showList.createTime" disabled/> -->
              </van-form>
              <div style="margin: 16px;">
                <van-button round block plain hairline type="info" @click="showPhoto(showList)" v-show="showList.photo==null?false:true">
                  查看照片</van-button>
                <!-- <van-button round block plain hairline type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                  确 定</van-button> -->
                  <van-button round block type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                    确 定</van-button>
              </div>
            </div>
          </div>
        </van-overlay>

          <van-popup v-model="show" >
          <div class="imgBox">
            <van-loading size="30px" type="spinner" color="#1989fa" v-show="loadingImg"></van-loading>
          <img :src="imgSrc" v-if="!loadingImg" >
          </div>
          </van-popup>
  </div>
</template>

<script>
import {ModifyApplyInfo,QueryApplyPhoto,QueryStationTask,UpdateTaskState} from '@/my_js//HttpRequest.js'
import {formatTime,getNowTime,formatDateTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
import { Notify,Dialog } from 'vant'
import PlateNumber from '../plateNo.vue'
import store from '../../store'
import {maskIdCard} from '@/utils/idNo.js'
export default {
  // mounted(){
  //   this.echartsInit()
  // },
  components:{
    PlateNumber,
  },
  filters:{
    formatTime:function(inputTime){
     return formatTime(inputTime)
    }
  },
 
  data(){
    return{
      dataForm:{
        id:'',
        applyState:-1,//申请状态
        plateType:-1,//车牌类型
        plateNo:'',//车牌号
        // idNo:'450881200010108922',
        idNo:'',//身份证号
        phoneNo:'',//手机号
        verifyNo:'',//验证码
        userPhoneNo:'',//管理员手机号
        dateBegin:null,//开始时间
        dateEnd:null,//结束时间
      },
      // exitDisable:false,//编辑按钮禁用
      isPlateNo:false,//是否为车牌号
      radio:'1',//1：身份证号查询，2：车牌号查询
      searchIdNoValue:'',//身份证号搜索内容
      searchPlateNoValue:'',//车牌号搜索内容
      // list:[],
      loading:false,
      loadingImg:false,
      finished:false,
      responseDataArray:[],//响应数据
      queryDataArray:[],//查询数据
      showDataDetail:false,//详情显示
      showList:[],//详情信息列表
      confirmShow:false,//修改确认
      // userName:'',//用户名
      confirmForm:{
        userPhoneNo:'',//身份证号
        userName:'',//用户名
      },
      showBegin:false,
      showEnd:false,
      minDate:new Date(2020,0,1),
      maxDate:new Date(2050,12,31),
      show:false,//是否显示图片
      imgSrc:null,//图片 base64 字符串
      zoom:1,
      queryDataLength:null,//查询到的数据量
      
    }
  },
  mounted(){
    // this.dataForm.dateBegin = getNowTime()//默认查询当天时间
    // this.dataForm.dateEnd = getNowTime()
    // this.onSearch()
    const end = new Date()
    const start = new Date()
    end.setTime(start.getTime() - 3600 * 1000 * 24 * 7)//默认查询7天时间
    const data = formatDateTime(end)
    console.log(data);
    this.dataForm.dateBegin = data
    this.dataForm.dateEnd = getNowTime()//当天时间
    this.onSearch()

    // this.image()

  },
  methods:{
    // 返回
    goBack(){
      console.log('返回服务站首页');
      this.$router.push('/stationIndex')
    },
    // 搜索
    onSearch(val){
      this.loading = true
      console.log('搜索输入内容：',val);
      const beginTime = formatBeginTime(this.dataForm.dateBegin)
      const endTime = formatEndTime(this.dataForm.dateEnd)
      const dataArray = {
        stationCode:store.state.stationUserInfo.stationCode,//工作站
        // stationCode:'130100008133',//工作站
        state:4,
        plateNo:'',//车牌号
        idNo:'',//身份证号
        dateBegin:beginTime,//开始时间
        dateEnd:endTime,//结束时间
      }
      console.log('dataArray:',dataArray);
      QueryStationTask(dataArray).then(res =>{
          console.log(res);
          this.responseDataArray = res.data
          this.queryDataArray = this.responseDataArray
          if(this.queryDataArray.length != 0){
            this.queryDataLength = this.queryDataArray.length
          }
          console.log( 'this.responseDataArray',this.responseDataArray);
          this.finished = true
          this.loading=false
        })
      
    },
    // 查询数据
    queryInfo(){
      // 将输入的身份证号和车牌号转换为大写
      // const formattedIdNo = this.trimmedStr(this.searchIdNoValue).toUpperCase();
      const formattedPlateNo = this.trimmedStr(this.searchPlateNoValue).toUpperCase();
      // console.log('formattedIdNo',formattedIdNo);
      console.log('formattedPlateNo',formattedPlateNo);
      
      // 按照车牌号进行查询
     if (formattedPlateNo) {
        this.queryByPlateNo(formattedPlateNo);
      } else{
        console.log('请输入搜索条件');
        this.onSearch()
      }

    },
     // 车牌号查询
     queryByPlateNo(plateNo){
      // 根据车牌号查询逻辑
      const filteredData = this.responseDataArray.filter(item =>
        item.plateNo.includes(plateNo)
      );
      console.log('车牌号查询结果:', filteredData);
      
      if(filteredData.length != 0){
        this.queryDataArray = filteredData
        this.queryDataLength = filteredData.length
        console.log('filteredData',this.filteredData);
      }else{
        this.queryDataArray = filteredData
        this.queryDataLength = null
        Notify({message:'暂无该车牌号信息，请稍后再查询',type:'warning'})
      }
     },
    // 去除空格
    trimmedStr(str){
      return str.replace(/\s+/g,'')
    },
    // 查看数据详情
    showDetail(val){
      console.log('val',val);
      this.showDataDetail = true
      val.createTime = formatTime(val.createTime)
      val.arriveTime = formatTime(val.arriveTime)
      val.confirmTime = formatTime(val.confirmTime)
      val.getTime = formatTime(val.getTime)
      this.showList = val
      this.showList.idNo = maskIdCard(this.showList.idNo)
    },
     // 获取车牌号
    getPlateNo(data){
        this.showList.plateNo = data
    },
    // 关闭编辑页面
    cancelForm(){
      // 清空搜索信息
      this.searchIdNoValue = ''
      this.searchPlateNoValue = ''
      this.onSearch()
      this.showDataDetail = false
    },
    // 提交修改数据
    confirmFrom(val){
      // debugger
      console.log(val);
      if(val.state != 0){
        this.showDataDetail = false
        // 清空搜索信息
        this.searchIdNoValue = ''
        this.searchPlateNoValue = ''
        this.onSearch()
      }else if (val.state == 0){
        // 验证身份证号
        const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
        const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
        if(!reg1.test(val.idNo) && !reg.test(val.idNo)){
          Notify({type:'warning',message:'请输入正确的身份证号'})
          return
        }

        if((this.showList.plateType == 0 && this.showList.plateNo.length != 7) || (this.showList.plateType == 1 && this.showList.plateNo.length != 8)){
          Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
          return
        }
        Dialog.confirm({
          title: '提示',
          message: '是否确定修改该用户的信息？',
        })
        .then(() => {
          // on confirm
          console.log('点击了确定');
          const dataArray = {
          id:this.showList.id,
          applyState:this.showList.state,
          plateType:this.showList.plateType,
          plateNo:this.showList.plateNo,
          idNo:this.showList.idNo,
          // userPhoneNo:this.confirmForm.userPhoneNo
          }   
          console.log('dataArray',dataArray);
          console.log(JSON.stringify(dataArray));
          ModifyApplyInfo(dataArray).then(res =>{
            console.log('修改申请数据：',res);
            Notify({type:'success',message:'修改'+res.msg})
            this.showDataDetail = false
            // 清空搜索信息
            this.searchIdNoValue = ''
            this.searchPlateNoValue = ''
            this.onSearch()
          })
        })
        .catch(() => {
          // on cancel
          console.log('点击了取消');
          this.showDataDetail = false
          // 清空搜索信息
          this.searchIdNoValue = ''
          this.searchPlateNoValue = ''
          this.onSearch()
        });
      }
      
    },
     // 选择日期并格式化时间
      onConfirmBegin(date){
        this.showBegin = false
        // 格式化时间
        this.dataForm.dateBegin = formatDateTime(date)
        console.log('开始时间：',this.dataForm.dateBegin);
        this.onSearch()
      },
      // 开始时间定位到 dateBegin
      clickBegin(date){
        this.showBegin = true
        this.$nextTick(() => {
          this.$refs.staHistory.reset(new Date(date))// 确保日历定位到指定时间
        })
      },
      // 选择日期并格式化时间
      onConfirmEnd(date){
      this.showEnd = false
      // 格式化时间
      this.dataForm.dateEnd = formatDateTime(date)
      console.log('结束时间：',this.dataForm.dateEnd);
      this.onSearch()
      },
      // 查看照片
      showPhoto(val){
        // debugger
        this.show = true
        this.loadingImg = true
        console.log(val);
        const photoPath = val.photo
        console.log('照片路径：',photoPath);
        QueryApplyPhoto(photoPath).then(res => {
          console.log(res);
          if(res.code == 0){
            // 查询图片成功
            // console.log(res.data);
            // 把返回的 base64 数据拼接上图片格式
            this.imgSrc = "data:image/png;base64,"+ res.data
            // this.show = true
            this.loadingImg = false
            this.image()
          }else{
            Notify({type:'warning',message:res.msg})
          }
        })
      },
      // 图片放大缩小
      image(){
        const content = document.querySelector('.imgBox')//获取需要放大缩小的盒子
        let firstDistance = 0 //存放手指开始放上的时候，两根手指之间的距离
        // 缩放事件的处理
        const getDistance = (start,stop) => {
          // 计算两根手指之间的距离
          return Math.sqrt(Math.pow(Math.abs(start.x - stop.x),2) + Math.pow(Math.abs(start.y - stop.y),2))
        }
        content.addEventListener('touchstart',function(event){
          // 获取第一次触摸的点
          const touches = event.touches
          if(touches.length > 1){// 判断是否是两指
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            firstDistance = getDistance(one,two)
          }
        })
        document.addEventListener('touchmove',(event) => {
          const touches = event.touches
          if(touches.length > 1){
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            const distance = getDistance(one,two)
            let zoom = distance / firstDistance
            content.style.zoom = this.zoom * zoom
          }
        })
        document.addEventListener('touchend',(event) => {
          this.zoom = content.style.zoom
        })
      },

   
  }

}
</script>

<style lang="scss" >
.history{
  .dataTime{
    .search{
    }
  }
  .searchContent{
    .van-cell__title{
      line-height: 45px;
    }
  }

  .van-nav-bar__left{
    left: 0;
  }
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .van-search__action{
    color: #0283ef;
    font-size: 18px;
  }

  .wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .title{
    margin-top: 3%;
    .cancel{
      float: right;
      margin-right: 3%;
      font-size: 28px;
    }
  }
  .applyBlock{
    width: 95%;
    // height: 68%;
    border-radius: 8px;
    background-color: #fff;
    .van-cell__value{
      text-align: left;
    }
    .van-field__control{
      width: 90%;
    }
  }
  .picWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

.picBlock {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

}
.van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
</style>